import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Check if credentials are still the default placeholders
const isPlaceholder = !supabaseUrl || 
                     !supabaseAnonKey || 
                     supabaseUrl.includes('your-project-ref') || 
                     supabaseUrl === '' ||
                     supabaseAnonKey.includes('your-supabase-anon-key');

if (isPlaceholder) {
  console.error(
    'CRITICAL ERROR: Supabase configuration is missing or using placeholders.\n' +
    'Please ensure your .env file is correctly populated.'
  );
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co', 
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true
    }
  }
);

export const checkSupabaseConfig = () => {
  if (isPlaceholder) {
    return {
      valid: false,
      error: 'Supabase configuration is not set. Please check your .env file settings.'
    };
  }
  return { valid: true };
};